// utils/relatoriosGlobais.js
import axios from 'axios';
import { API_BASE_URL } from '../../config/ApiConfig';

// Função para gerar relatórios com filtro de programa e período
export const gerarRelatorioComProgramaPeriodo = async (
  endpoint,
  dadosFiltro,
  nomeRelatorio = 'Relatório',
  openPdfViewer = null
) => {
  try {
    const token = localStorage.getItem('token');
    const cnpj = localStorage.getItem('cnpj');
    const anoBase =
      parseInt(localStorage.getItem('anoBase')) || new Date().getFullYear();

    if (!token || !cnpj) {
      throw new Error('Token ou CNPJ não encontrados');
    }

    const { dataInicio, dataFim, programa } = dadosFiltro;

    console.log(dadosFiltro);

    const response = await axios.get(`${API_BASE_URL.RELATORIO}/${endpoint}`, {
      params: {
        cnpjAssociacao: cnpj,
        anoBase: anoBase,
        dataInicio,
        dataFim,
        idPrograma: programa.id,
        nomePrograma: programa.descricao,
      },
      headers: { Authorization: `Bearer ${token}` },
      responseType: 'blob',
    });

    validateAndOpenPdf(response, openPdfViewer, nomeRelatorio);
    return { success: true, message: `${nomeRelatorio} gerado com sucesso!` };
  } catch (error) {
    console.error(`Erro ao gerar ${nomeRelatorio}:`, error);
    return {
      success: false,
      message: error.message || `Erro ao gerar ${nomeRelatorio}`,
    };
  }
};

// Função utilitária para validar e abrir PDF
const validateAndOpenPdf = (response, openPdfViewer = null, title = 'Relatório') => {
  // Verificar status da resposta
  if (response.status !== 200) {
    throw new Error(`Erro no servidor: ${response.status}`);
  }

  // Verificar se há dados na resposta
  if (!response.data || response.data.size === 0) {
    throw new Error('PDF não foi gerado corretamente - arquivo vazio');
  }

  // Verificar se é realmente um PDF (verificação adicional)
  const contentType = response.headers['content-type'];
  if (contentType && !contentType.includes('application/pdf')) {
    console.warn('Tipo de conteúdo inesperado:', contentType);
  }

  // Se chegou até aqui, o PDF está válido
  const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
  const pdfUrl = URL.createObjectURL(pdfBlob);
  
  if (openPdfViewer) {
    openPdfViewer(pdfUrl, title);
  } else {
    window.open(pdfUrl, '_blank');
    setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
  }
  return true;
};

// Função para gerar Lista de Despesas
export const gerarListaDespesas = async (openPdfViewer) => {
  try {
    const token = localStorage.getItem('token');
    const cnpj = localStorage.getItem('cnpj');
    const anoBase =
      parseInt(localStorage.getItem('anoBase')) || new Date().getFullYear();

    if (!token || !cnpj) {
      throw new Error('Token ou CNPJ não encontrados');
    }

    const response = await axios.get(
      `${API_BASE_URL.RELATORIO}/lista_despesa`,
      {
        params: { cnpjAssociacao: cnpj, ano: anoBase },
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      }
    );

    validateAndOpenPdf(response, openPdfViewer, 'Despesas Gerais');
    return true;
  } catch (error) {
    console.error('Erro ao gerar Lista de Despesas:', error);
    throw error;
  }
};

// Função para gerar Lista de Despesas por Mês
export const gerarListaDespesasPorMes = async (mes, openPdfViewer) => {
  try {
    const token = localStorage.getItem('token');
    const cnpj = localStorage.getItem('cnpj');
    const anoBase =
      parseInt(localStorage.getItem('anoBase')) || new Date().getFullYear();

    if (!token || !cnpj) {
      throw new Error('Token ou CNPJ não encontrados');
    }

    if (!mes || mes < 1 || mes > 12) {
      throw new Error('Mês inválido');
    }

    const response = await axios.get(
      `${API_BASE_URL.RELATORIO}/lista_despesa_mes`,
      {
        params: {
          cnpjAssociacao: cnpj,
          ano: anoBase,
          mes: mes,
        },
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      }
    );

    validateAndOpenPdf(response, openPdfViewer, 'Despesas por Mês');
    return true;
  } catch (error) {
    console.error('Erro ao gerar Lista de Despesas por Mês:', error);
    throw error;
  }
};

// Função para gerar Lista de Despesas por Período (Data de Elaboração)
export const gerarListaDespesasPorPeriodo = async (dataInicio, dataFim, openPdfViewer) => {
  try {
    const token = localStorage.getItem('token');
    const cnpj = localStorage.getItem('cnpj');
    const anoBase =
      parseInt(localStorage.getItem('anoBase')) || new Date().getFullYear();

    if (!token || !cnpj) {
      throw new Error('Token ou CNPJ não encontrados');
    }

    if (!dataInicio || !dataFim) {
      throw new Error('Datas de início e fim são obrigatórias');
    }

    // Validar se data início é menor que data fim
    if (new Date(dataInicio) > new Date(dataFim)) {
      throw new Error('Data de início deve ser menor que data de fim');
    }

    console.log('Gerando relatório de despesas por período:', {
      cnpj,
      anoBase,
      dataInicio,
      dataFim,
    });
    const response = await axios.get(
      `${API_BASE_URL.RELATORIO}/lista_despesa_periodo`,
      {
        params: {
          cnpjAssociacao: cnpj,
          ano: anoBase,
          dataInicio: dataInicio,
          dataFim: dataFim,
        },
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      }
    );

    validateAndOpenPdf(response, openPdfViewer, 'Despesas por Período');
    return true;
  } catch (error) {
    console.error('Erro ao gerar Lista de Despesas por Período:', error);
    // Se o endpoint específico não existir, tentar com endpoint genérico
    if (error.response && error.response.status === 404) {
      console.warn(
        'Endpoint período não encontrado, usando endpoint genérico...'
      );
      try {
        const alternativeResponse = await axios.get(
          `${API_BASE_URL.RELATORIO}/lista_despesa`,
          {
            params: {
              cnpjAssociacao: cnpj,
              ano: anoBase,
              dataInicio: dataInicio,
              dataFim: dataFim,
            },
            headers: { Authorization: `Bearer ${token}` },
            responseType: 'blob',
          }
        );
        validateAndOpenPdf(alternativeResponse);
        return true;
      } catch (altError) {
        console.error('Erro no endpoint alternativo:', altError);
        throw new Error('Relatório por período não está disponível no momento');
      }
    }
    throw error;
  }
};

// Lista de relatórios globais sempre disponíveis
export const relatoriosGlobais = [
  {
    label: 'Despesas Gerais',
    icon: 'bi bi-file-earmark-pdf',
    action: gerarListaDespesas,
  },
  {
    label: 'Despesas por Mês',
    icon: 'bi bi-calendar-month',
    action: gerarListaDespesasPorMes,
    requiresMes: true, // Flag para indicar que precisa de seleção de mês
    tooltip: 'Gera relatório filtrado por mês específico',
  },
  {
    label: 'Despesas por Período',
    icon: 'bi bi-calendar-range',
    action: gerarListaDespesasPorPeriodo,
    requiresPeriodo: true, // Flag para indicar que precisa de seleção de período
    tooltip: 'Gera relatório filtrado por período de data de elaboração',
  },
  {
    label: 'Despesas por Programa e Período',
    icon: 'bi bi-graph-up',
    action: 'despesa_programa_periodo', // Endpoint para usar com gerarRelatorioComProgramaPeriodo
    requiresProgramaPeriodo: true, // Flag para indicar que precisa de seleção de programa e período
    tooltip: 'Gera relatório de despesas filtrado por programa e período',
  },
  // {
  //   label: 'Receitas por Programa e Período',
  //   icon: 'bi bi-cash-coin',
  //   action: dadosFiltro =>
  //     gerarRelatorioComProgramaPeriodo(
  //       'receitas_programa',
  //       dadosFiltro,
  //       'Relatório de Receitas por Programa'
  //     ),
  //   requiresProgramaPeriodo: true, // Flag para indicar que precisa de seleção de programa e período
  //   tooltip: 'Gera relatório de receitas filtrado por programa e período',
  // },
  // Adicione outros relatórios globais aqui
];
